import { render } from "./NoteStockZeroPopUp.vue?vue&type=template&id=198d1df1"
import script from "./NoteStockZeroPopUp.vue?vue&type=script&lang=js"
export * from "./NoteStockZeroPopUp.vue?vue&type=script&lang=js"

import exportComponent from "/Users/chrisfinlayson/Desktop/WORK/riverhawk-nest/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__